import KTCookie from "@/assets/js/components/cookie.js";

export const parseDebugCookie = debugCookie => {
  if (debugCookie && typeof debugCookie === "string") {
    const parsedCookie = debugCookie.split(":");
    return parsedCookie;
  }

  return "";
};

export const handleDebugCookie = debugCookie => {
  if (debugCookie && typeof debugCookie === "string") {
    const parsedCookie = parseDebugCookie(debugCookie);
    if (parsedCookie.length > 1) {
      if (parsedCookie[1] === "delete") {
        KTCookie.deleteCookie(parsedCookie[0]);
        console.log("HAPI: removed debug cookie", parsedCookie[0]);
      } else {
        KTCookie.setCookie(parsedCookie[0], parsedCookie[1]);
        console.log("HAPI: set debug cookie", parsedCookie[0], parsedCookie[1]);
      }
    }
  }
};
